import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  insuranceClaimsData: {},
  insuranceClaimsStatus: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'insuranceClaims',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchInsuranceClaimsData: (state, action) => {
      state.insuranceClaimsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postInsuranceClaimsData: (state, action) => {
      state.insuranceClaimsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetStatus: (state) => {
      state.insuranceClaimsStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchError,
  fetchInsuranceClaimsData,
  postInsuranceClaimsData,
  resetMsg,
  resetStatus,
} = slice.actions;
export const fetchInsuranceClaims = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      //   httpPost("lookup/find/all/lookup", {
      //     typeCode: [INTEREST_TABLE, INTEREST_FREQUENCY, INTEREST_STEP_TABLE],
      //   }),
      httpGet(`${CLIENT_MAINTENANCE}/find/clienticeclaimsinf/${clientNumber}`),
    ])
      .then((data) => {
        const interestData = data && data[0] ? data[0] : null;
        if (interestData?.status && interestData.status === 200) {
          dispatch(fetchInsuranceClaimsData(interestData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postInsuranceClaims = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/clienticeclaimsinf`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postInsuranceClaimsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetInsuranceClaimsStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
